import type { CategoryType } from '@/types/movie';
import { REGION_OPTIONS, YEAR_OPTIONS, GENRE_OPTIONS } from '@/types/movie';

interface FilterBarProps {
  category: CategoryType;
  region: string;
  year: string;
  genre: string;
  sort: string;
  onChange: (key: 'region' | 'year' | 'genre', value: string) => void;
}

const SORTS = [
  { key: 'recommend', label: '默认推荐' },
  { key: 'time', label: '上映时间' },
  { key: 'heat', label: '热度' },
];

function OptionRow({
  label,
  options,
  value,
  onSelect,
}: {
  label: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 py-3 border-b border-background-200/70 last:border-0">
      <span className="shrink-0 w-16 pt-1 text-sm font-medium text-foreground-600">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onSelect(opt)}
            className={`whitespace-nowrap rounded-md px-3 py-1.5 text-sm transition-colors ${
              value === opt
                ? 'bg-primary-500 font-semibold text-background-50'
                : 'text-foreground-700 hover:bg-primary-50 hover:text-primary-600'
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({ category, region, year, genre, onChange }: FilterBarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <OptionRow
        label="地区"
        options={REGION_OPTIONS}
        value={region}
        onSelect={(v) => onChange('region', v)}
      />
      <OptionRow
        label="年份"
        options={YEAR_OPTIONS}
        value={year}
        onSelect={(v) => onChange('year', v)}
      />
      <OptionRow
        label="类型"
        options={GENRE_OPTIONS[category]}
        value={genre}
        onSelect={(v) => onChange('genre', v)}
      />
    </div>
  );
}

export { SORTS };